import { onMounted, ref, useContext } from '@nuxtjs/composition-api';
import useRecaptcha from '~/composables/useRecaptcha';

export default function useForm() {
  const { $recaptcha, $axios } = useContext();
  const { validateRecaptcha } = useRecaptcha();

  const error = ref();
  const success = ref();
  const pending = ref(false);

  const submitForm = async (
    formData: Record<string, any>,
    formId: string = '',
  ) => {
    pending.value = true;
    try {
      error.value = null;
      await $axios.post(`/api/forms/${formId}`, formData);
      success.value = true;
    } catch (e) {
      error.value = e;
    } finally {
      pending.value = false;
    }
  };

  onMounted(async () => {
    try {
      await $recaptcha.init();
    } catch (e) {
      console.error(e);
    }
  });

  async function submit(formData: object, formId?: string) {
    await validateRecaptcha();
    await submitForm(formData, formId);
  }

  return { submit, pending };
}
